import React from 'react';
import { useIntl } from 'react-intl';
import {
  ProSidebar,
  Menu,
  MenuItem,
  SubMenu,
  SidebarHeader,
  SidebarFooter,
  SidebarContent,
} from 'react-pro-sidebar';
import { Button } from 'react-bootstrap';
import ReactDOM from 'react-dom';

import sidebarBg from './assets/bg1.jpg';
import profile_pic from './img/mypic.jpg'
import './App.css';


function Add_Menuitem(){
  var d=document.getElementById("menu").getRootNode;
  var d1=document.getElementById("About");
  var node = document.createElement("LI");                 // Create a <li> node
  var textnode = document.createTextNode("Water");         // Create a text node
  node.appendChild(textnode); 
  //d.appendChild(node);
  console.log(d);
}
const Aside = ({ image, collapsed, rtl, toggled, handleToggleSidebar }) => {
  function Onfileload(e){
    console.log("ahddada");
    const file=e.currentTarget.files[0];
let filereader=new FileReader();
filereader.onload=()=>{

  console.log("image load",filereader.result);
  const file={
    name:file.name,
    size:file.size,
    type:file.type,
    data:filereader.result
  }
  console.log("image",file.name);

}
filereader.onabort=()=>{
  console.log("image abort");
}
filereader.onerror=()=>{
  console.log("image errir");
}
filereader.readAsDataURL(file);

  };
  const intl = useIntl();
  return (
    <ProSidebar
      image={image ? sidebarBg : false}
      rtl={rtl}
      collapsed={collapsed}
      toggled={toggled}
      breakPoint="md"
      onToggle={handleToggleSidebar}
    >
      <SidebarHeader>
        <div
          style={{
            padding: '24px',
            textTransform: 'uppercase',
            fontWeight: 'bold',
            fontSize: 14,
            letterSpacing: '1px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
           
      <span class="d-none d-lg-block">
        <p>Draw your profile picture her</p>
        <div className="draggable-container">
        <input
        type="file"
id="file_browser_input"
name="file_browser_input" 
onDragOver={(e)=>{
  e.preventDefault();
  e.stopPropagation();
}}
onDrop={Onfileload.bind(this)}
onChange={Onfileload.bind(this)}

        />
        </div>
       
        <img class="img-fluid img-profile rounded-robin mx-auto mb-2" id="image" src={profile_pic} alt=""/>
      </span>
        </div>
      </SidebarHeader>

      <SidebarContent>
        <Menu iconShape="circle" id="menu">
          <MenuItem
          onClick={Add_Menuitem}
          >
            {intl.formatMessage({  id: 'About' })}
          </MenuItem>
          <MenuItem > {intl.formatMessage({ id: 'Experience' })}</MenuItem>
          <Button onClick={Add_Menuitem} variant="outline-dark">Dark</Button>

        </Menu>
       
      </SidebarContent>

      <SidebarFooter style={{ textAlign: 'center' }}>
        <div
          className="sidebar-btn-wrapper"
          style={{
            padding: '20px 24px',
          }}
        >
          
        </div>
      </SidebarFooter>
    </ProSidebar>
  );
};

export default Aside;
